<template>
  <a-info-validation
    :hint="hint"
    :error-messages="errorMessages"
    control-class="form-control file-input-container"
  >
    <label class="file-select">
      <div class="row no-gutters justify-space-between">
        <div class="col">
          <span v-if="activeFile">{{ activeFile.name }}</span>
          <span v-else>{{ placeholder }}</span>
          <input type="file" :accept="accept" @change="handleFileChange" />
        </div>
        <div v-if="activeFile" class="col col-auto align-self-end pb-0">
          <button type="button" @click="activeFile = undefined">
            <i class="pf-times" />
          </button>
        </div>
      </div>
    </label>
  </a-info-validation>
</template>

<script>
import InfoValidation from "+/components/form/infoValidation/InfoValidation";

export default {
  components: {
    "a-info-validation": InfoValidation
  },
  model: {
    prop: "file",
    event: "change"
  },
  props: {
    file: File,
    placeholder: {
      type: String,
      default: ""
    },
    accept: {
      type: String,
      default: ""
    },
    hint: {
      type: String,
      default: ""
    },
    errorMessages: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data: () => ({ activeFile: undefined }),
  computed: {
    errorState: {
      get() {
        return this.errorMessages.length > 0;
      }
    }
  },
  methods: {
    handleFileChange(e) {
      this.activeFile = e.target.files[0];
      this.$emit("change", e.target.files[0]);
    }
  }
};
</script>
